export function createUrl(pathname) {
    const { protocol, host} = new URL(window.location.href);
    return new URL(pathname, `${protocol}//${host}`);
};

export function createEl() {
    const refs = {};
    function el(...args) {
        const tag = args[0];
        let attrs;
        let content;

        if(typeof args[1] === "object" && !Array.isArray(args[1])) {
            attrs = args[1];
            content = args[2];
        } else {
            content = args[1];
        }

        let element;
        if(["svg", "path"].includes(tag)) {
            element = document.createElementNS("http://www.w3.org/2000/svg", tag);
        } else {
            element = document.createElement(tag);
        }
        if(Array.isArray(content)) {
            for(const item of content) {
                element.append(item);
            }
        } else if(typeof content !== "undefined") {
            element.textContent = content.toString();
        }
        if(attrs) {
            for(const attr in attrs) {
                if(attrs.hasOwnProperty(attr)) {
                    if(typeof refs === "object" && attr === "ref") {
                        refs[attrs[attr]] = element;
                    } else {
                        element.setAttribute(attr, attrs[attr]);
                    }
                }
            }
        }
        return element;
    }

    return [el, refs];
}

export function pushUrl(url, rerender = true) {
    history.pushState(null, "", url);
    if(rerender) {
        window.dispatchEvent(new CustomEvent("popstate"));
    }
}

export function replaceUrl(url, rerender = true) {
    history.replaceState(null, "", url);
    if(rerender) {
        window.dispatchEvent(new CustomEvent("popstate"));
    }
}

export class Observable {
    constructor(data) {
        this.data = data;
        this.listeners = [];
    }

    get value() {
        return this.data;
    }

    set value(data) {
        this.data = data;
        for(const listener of this.listeners) {
            if(typeof listener === "function") {
                listener();
            }
        }
    }

    subscribe(listener) {
        this.listeners.push(listener);
    }
}

export function parseCookies() {
    const items = document.cookie.split(';'); // Split the string into individual cookie strings
    const cookies = {};

    for(const item of items) {
        const pair = item.trim().split("=");
        if(pair.length !== 2) {
            continue;
        }

        const key = decodeURIComponent(pair[0]);
        const value = decodeURIComponent(pair[1]);
        cookies[key] = value;
    }

    return cookies;
}

export function testCookies() {
    const cookies = parseCookies();
    if(typeof cookies.userId === "undefined") {
        replaceUrl("/login");
        throw new Error("Session expired");
    }
}


